export const getAvailableModelDefinitions = (modelDefinitions) => {
    var _a;
    return ((_a = modelDefinitions === null || modelDefinitions === void 0 ? void 0 : modelDefinitions.filter(md => md.type === 'REQUIRED' || md.type === 'OPTIONAL' || md.type === 'RECOMMENDED')) !== null && _a !== void 0 ? _a : []);
};
export const getAvailableModelConfigurations = (modelDefinitions) => getAvailableModelDefinitions(modelDefinitions).map(md => ({
    id: md.model.id,
    label: md.model.modelName,
    required: md.type === 'REQUIRED',
    recommended: md.type === 'RECOMMENDED'
}));
export const getUnavailableModelDefinitions = (modelDefinitions) => {
    var _a;
    return (_a = modelDefinitions === null || modelDefinitions === void 0 ? void 0 : modelDefinitions.filter(md => md.type === 'REMOVED' || md.type === 'MIGRATED')) !== null && _a !== void 0 ? _a : [];
};
export const getUnavailableModelConfigurations = (modelDefinitions) => getUnavailableModelDefinitions(modelDefinitions).map(md => {
    var _a;
    return ({
        id: md.model.id,
        label: md.model.modelName,
        removed: md.type === 'REMOVED',
        migrateTo: (_a = md.migrateTo) === null || _a === void 0 ? void 0 : _a.id
    });
});
export const getProvider = (aiConfiguration, provider) => {
    return aiConfiguration === null || aiConfiguration === void 0 ? void 0 : aiConfiguration.availableProviders.find(p => p.type === provider);
};
export const getDefaultModels = (aiConfiguration, provider, openAIPreset = 'AZURE') => {
    var _a, _b;
    return (_b = (_a = getModelDefinitions(aiConfiguration, provider, openAIPreset)) === null || _a === void 0 ? void 0 : _a.filter(md => md.type === 'REQUIRED').map(md => md.model)) !== null && _b !== void 0 ? _b : [];
};
export const getModelDefinitions = (aiConfiguration, provider, openAIPreset) => {
    var _a, _b, _c, _d, _e, _f, _g;
    switch (provider) {
        case 'openai':
            return openAIPreset !== undefined
                ? (_b = (_a = getProvider(aiConfiguration, provider)) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b[openAIPreset]
                : (_d = (_c = getProvider(aiConfiguration, provider)) === null || _c === void 0 ? void 0 : _c.models) === null || _d === void 0 ? void 0 : _d.AZURE;
        case 'google':
            return (_e = getProvider(aiConfiguration, provider)) === null || _e === void 0 ? void 0 : _e.models;
        case 'bedrock':
            return (_f = getProvider(aiConfiguration, provider)) === null || _f === void 0 ? void 0 : _f.models;
        case 'huggingFace':
            return (_g = getProvider(aiConfiguration, provider)) === null || _g === void 0 ? void 0 : _g.models;
        case 'jetbrains':
            return [];
        case 'mellum':
            return [];
        default:
            return assert_exhaustive(provider);
    }
};
